// extracted by mini-css-extract-plugin
export default {"Editor":"HtmlContentEditor_Editor__haM-9","FloatingButton":"HtmlContentEditor_FloatingButton__Lw3Y5"};